import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-cream" data-id="element-155">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cream-light via-cream to-cream-dark -z-10" data-id="element-156"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-158">
          <div className="inline-block px-3 py-1 rounded-full border border-navy/20 bg-navy/5 text-navy font-bold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-159">
            📚 Spanish Ready™ Mega Pack
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-navy" data-id="element-160">
            Everything you need to teach Spanish all year —{' '}
            <span className="text-turquoise-gradient" data-id="element-161">ready to use today.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[260px] sm:max-w-md md:max-w-xl mb-4 sm:mb-6" data-id="element-162">
          <div className="absolute inset-0 bg-turquoise/20 blur-[80px] rounded-full" data-id="element-163"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gjJvSzePirLXxTe3M1o8xj/seguridad_e_higiene_(2).png" alt="Spanish Ready Mega Pack" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-164" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-165">
          <p className="text-sm sm:text-lg md:text-xl text-navy-light leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-166">
            The complete 6-in-1 system to plan, teach, and assess — ready to use
            from day one.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-167">
            <Button href="#pricing" className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-168">
              🟡 I WANT MY MEGA PACK NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-navy-light font-medium" data-id="element-169">
            <div className="flex items-center gap-1.5" data-id="element-170">
              <CheckCircle size={14} className="text-turquoise" data-id="element-171" />
              <span data-id="element-172">6-in-1 complete system</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <CheckCircle size={14} className="text-turquoise" data-id="element-174" />
              <span data-id="element-175">5 exclusive bonus packs</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-176">
              <CheckCircle size={14} className="text-turquoise" data-id="element-177" />
              <span data-id="element-178">Immediate access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}